<template>
  <div>
    <back-profile v-if="studentProfile" @click.native="navigateTo('app.profile.home')"
      >Perfil de {{ studentProfile.student.name }}</back-profile
    >

    <!-- Active alerts -->
    <block>
      <template slot="header"
        >Atenciones ({{ this.studentAttentions.length }})</template
      >
      <template slot="actions">
        <button
          class="button is-primary is-outlined"
          @click="navigateTo('app.profile.add_attention')"
        >
          + Agregar
        </button>
      </template>
      <alert-item-list
        :items="this.orderedGroupOfAttentions(studentGroupOfAttentions)"
        :key-field="'id'"
        @item-selected="goToAttention"
      >
        <template slot="icon" slot-scope="{ item }">
          <span v-if="item.status == 'PENDING'">
            <img class="icon icon-svg" src="@/static/svg/icono_pendiente_v2.svg" alt="pendiente" />
          </span>
          <span v-if="item.status == 'COMPLETED'">
            <img class="icon icon-svg" src="@/static/svg/icono_check_v2.svg" alt="completado" />
          </span>
          <span v-if="item.status == 'FAILED'">
            <img class="icon icon-svg" src="@/static/svg/icono_nocheck_v2.svg" alt="fallido" />
          </span>
        </template>
        <template slot="title" slot-scope="{ item }"
          >{{ item.title }} ({{ item.finished }}/{{ item.total }})</template
        >
        <template slot="description" slot-scope="{ item }">
          <span>{{ formatAttentionDate(item) }}</span>
        </template>
      </alert-item-list>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"
import STUDENT_ATTENTIONS from "./graphql/StudentAttentions.gql"
import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import AlertItemList from "@/components/_base/AlertItemList.vue"

function humanizeDate(date) {
  if (date == null) {
    return "-"
  } else {
    const m = moment(date)
    return m.fromNow()
  }
}

export default {
  name: "ProfileAttentions",

  props: {
    studentId: {
      type: String
    }
  },

  data() {
    return {
      studentProfile: {
        student: {
          name: ""
        }
      },
      studentAttentions: []
    }
  },

  apollo: {
    studentProfile: {
      query: gql`
        query StudentProfile($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              name
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    },

    studentAttentions: {
      query: STUDENT_ATTENTIONS,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },

  computed: {
    studentGroupOfAttentions() {
      let groupOfAttentions = []

      this.studentAttentions.map(attention => {
        if (groupOfAttentions.length < 1) {
          groupOfAttentions.push([attention])
        } else {
          for (let i = 0; i < groupOfAttentions.length; i++) {
            let wasAdded = false
            let group = groupOfAttentions[i]

            if (group[0].action.id === attention.action.id) {
              group.push(attention)
              break
            }

            if (i === groupOfAttentions.length - 1 && !wasAdded) {
              groupOfAttentions.push([attention])
              break
            }
          }
        }
      })

      return groupOfAttentions
    }
  },

  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    attentionTitle(item) {
      if (item.action.plan && item.action.plan.category) {
        let title = item.action.plan.category.name
        if (!item.action.plan.hidden && item.action.plan) title += " - " + item.action.plan.name
        if (!item.action.hidden && item.action) title += " - " + item.action.name
        return title
      } else {
        return item.action.name
      }
    },
    getTotalAttentionsOfGroup(a) {
      let len
      this.studentGroupOfAttentions.map(function(g) {
        if (g[0].action.id === a.action.id) {
          len = g.length
        }
      })
      return len
    },
    getAttentionsFinished(a) {
      let attentionsFinished = 0

      this.studentGroupOfAttentions.map(function(g) {
        if (g[0].action.id === a.action.id) {
          g.map(attention => {
            if (attention.status != "PENDING") {
              attentionsFinished++
            }
          })
          return attentionsFinished
        }
      })

      return attentionsFinished
    },
    formatAttentionDate(attention) {
      let status
      if (attention.status == "PENDING") status = "pendiente"
      if (attention.status == "COMPLETED") status = "realizada"
      if (attention.status == "FAILED") status = "fallida"
      return `${humanizeDate(attention.dueBy)}`
    },
    goToAttention(attention) {
      this.$emit("hello", {
        state: "app.profile.attentions_by_type",
        params: {
          attentionActionId: attention.action.id
        }
      })
    },
    orderedGroupOfAttentions(groupOfAttentions) {
      let orderedAttentions = []
      const attentions = this.getAttentionsToShow(groupOfAttentions)

      for (let i = 0; i < attentions.length; i++) {
        if (attentions[i].status === "PENDING") {
          orderedAttentions.unshift(attentions[i])
        } else {
          orderedAttentions.push(attentions[i])
        }
      }

      return orderedAttentions
    },
    getAttentionsToShow(groupOfAttentions) {
      let attentionsToShow = []

      groupOfAttentions.map(group => {
        if (this.someAttentionsIsNotFinished(group)) {
          attentionsToShow.push(this.getNextAttention(group))
        } else {
          attentionsToShow.push(this.getLastAttention(group))
        }
      })

      return this.formatGroupOfAttentions(attentionsToShow)
    },
    someAttentionsIsNotFinished(group) {
      group.map(a => {
        if (a.status == "PENDING") {
          return true
        }
      })
      return false
    },
    formatGroupOfAttentions(attentions) {
      return attentions.map(a => {
        const total = this.getTotalAttentionsOfGroup(a)
        const title = this.attentionTitle(a)
        const finished = this.getAttentionsFinished(a)

        return {
          ...a,
          title,
          total,
          finished
        }
      })
    },
    getNextAttention(groupOfAttentions) {
      //  get date of dueBy
      let nextAttention = null

      groupOfAttentions.map(a => {
        if (!nextAttention) {
          nextAttention = a
        } else {
          let nextAttentionDate = new Date(nextAttention.dueBy)
          let currentAttentionDate = new Date(a.dueBy)

          if (nextAttentionDate - currentAttentionDate < 0) {
            nextAttentionDate = a
          }
        }
      })

      return nextAttention
    },
    getLastAttention(groupOfAttentions) {
      // get date of performedAt or something else (?)
      let nextAttention = null

      groupOfAttentions.map(a => {
        if (!nextAttention) {
          nextAttention = a
        } else {
          let nextAttentionDate = new Date(nextAttention.performedAt)
          let currentAttentionDate = new Date(a.performedAt)

          if (nextAttentionDate - currentAttentionDate < 0) {
            nextAttentionDate = a
          }
        }
      })

      return nextAttention
    }
  },

  components: {
    Block,
    AlertItemList,
    BackProfile
  },

  filters: {
    humanizeDate
  }
}
</script>
